import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const {
	colors,
	common: { borderRadius },
	spacing,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		width: 450,
	},
	headerRow: {
		justifyContent: 'flex-end',
		color: colors.text.main,
	},
	tagListBuilder: {
		margin: spacing.none,
	},
	textInput: {
		borderRadius,
		width: '100%',
	},
	titleRow: {
		justifyContent: 'flex-start',
		fontSize: 18,
		margin: 0,
	},
	formContainer: {
		gap: spacing.md,
	},
	formRow: {
		gap: spacing.md,
		alignItems: 'flex-end',
	},
	destructive: {
		backgroundColor: colors.danger.main,
		':hover': {
			backgroundColor: colors.warning.main,
		},
		':disabled': {
			backgroundColor: colors.danger.main,
			opacity: 0.5,
		},
	},
	buttonRow: {
		gap: spacing.md,
		justifyContent: 'center',
	},
	checkboxRow: {
		gap: spacing.sm,
	},
	warningRow: {
		justifyContent: 'center',
	},
	marginNone: {
		margin: spacing.none,
	},
	paragraphSize: {
		fontSize: 14,
		textAlign: 'center',
	},
	warningText: {
		color: colors.primary.main,
		textAlign: 'center',
		margin: spacing.none,
	},
});
